import { render, staticRenderFns } from "./SafeSchedule.vue?vue&type=template&id=bbd72f3c&scoped=true&"
import script from "./SafeSchedule.vue?vue&type=script&lang=js&"
export * from "./SafeSchedule.vue?vue&type=script&lang=js&"
import style0 from "./SafeSchedule.vue?vue&type=style&index=0&id=bbd72f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd72f3c",
  null
  
)

export default component.exports